import template   from './help.html'
import controller from './help.controller'

import './help.styl'

let component = {
  restrict: 'E',
  template,
  controller
}

export default component



// WEBPACK FOOTER //
// ./src/app/pages/help/help.component.js